import { $api } from "../../../store/api/api";

import { EndpointsEnum } from "../../../constants/endpoints";

import { IPostTicketUser, IPostTicketUserBody, IPostTicketUserResponse } from "./post-ticket-user.types";
import { IRestResponse } from "../../../types/response";

export const postTicketUser: IPostTicketUser = async (body: IPostTicketUserBody) => {
    const response = await $api.post<IRestResponse<IPostTicketUserResponse>>(`${EndpointsEnum.POST_TICKET_USER}`, body);

    return response.data;
};
